var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLtc01 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#345D9D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 250,
    r: 217.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250,6C115.2,6,6,115.2,6,250s109.2,244,244,244s244-109.2,244-244l0,0l0,0C494.4,115.6,385.8,6.4,251.4,6 c0,0,0,0,0,0H250z M254.1,258.3l-25.4,85.7h135.9c3.8-0.1,7,2.8,7.1,6.6c0,0,0,0,0,0v2.2l-11.8,40.8c-1.1,4-4.8,6.7-8.9,6.5h-208 l34.9-118.8l-39,11.8l8.9-27.2l39-11.8l49-166.6c1.1-3.9,4.8-6.6,8.9-6.5h52.6c3.8-0.1,7,2.8,7.1,6.6c0,0,0,0,0,0v2.2L263,230.5 l39-11.8l-8.3,28.4L254.1,258.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLtc01);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LTC-01.258e301cbf8b3e2752bdbac93f5d1ba4.svg";